module.exports = __webpack_public_path__ + "static/media/staticmap.f47f3f23.png";